var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraAdd = function SvgCameraAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera_add_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".camera_add_svg__st0{fill:#666}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera_add_svg__Icon-Camera",
    transform: "translate(178 530)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "camera_add_svg__st0",
    d: "M-128.6-510.2h-7.4c-.3 0-.6-.2-.7-.4l-1.3-2.7c-.5-1-1.8-1.8-2.9-1.8h-9.7c-1.1 0-2.4.8-2.9 1.8l-1.3 2.7c-.1.1-.5.4-.7.4h-7.4c-2 0-3.7 1.7-3.7 3.7v22c0 2 1.7 3.7 3.7 3.7h24.6c0-.8-.1-1.7-.1-2.5h-24.4c-.7 0-1.2-.5-1.2-1.2v-22c0-.7.5-1.2 1.2-1.2h7.4c1.1 0 2.4-.8 2.9-1.8l1.3-2.7c.1-.1.5-.4.7-.4h9.7c.3 0 .6.2.7.4l1.3 2.7c.5 1 1.8 1.8 2.9 1.8h7.4c.7 0 1.2.5 1.2 1.2v11.8h2.4v-11.8c0-2-1.7-3.7-3.7-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_add_svg__Fill-22_1_",
    className: "camera_add_svg__st0",
    d: "M-145.7-485.7c-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11-4.9 11-11 11zm0-19.6c-4.7 0-8.6 3.9-8.6 8.6s3.9 8.6 8.6 8.6 8.6-3.9 8.6-8.6-3.8-8.6-8.6-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_add_svg__Fill-23_1_",
    className: "camera_add_svg__st0",
    d: "M-132.2-505.3c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2.5-1.2 1.2-1.2c.6 0 1.2.6 1.2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_add_svg__Fill-24_1_",
    className: "camera_add_svg__st0",
    d: "M-161.6-512.6h4.9v1.2h-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_add_svg__Fill-25_1_",
    className: "camera_add_svg__st0",
    d: "M-145.7-501.6v-1.2c-3.3 0-6.1 2.7-6.1 6.1h1.2c0-2.7 2.2-4.9 4.9-4.9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50.7 36.9c-5.1 0-9.3 4.2-9.3 9.3s4.2 9.3 9.3 9.3 9.3-4.2 9.3-9.3-4.2-9.3-9.3-9.3zM56 47c0 .4-.4.7-.7.7h-3.2v3.2c0 .4-.4.7-.7.7H50c-.4 0-.7-.4-.7-.7v-3.2h-3.2c-.4 0-.7-.4-.7-.7v-1.4c0-.4.4-.7.7-.7h3.2v-3.2c0-.4.4-.7.7-.7h1.4c.4 0 .7.4.7.7v3.2h3.2c.4 0 .7.4.7.7V47z",
    style: {
      fill: "#00cb65"
    }
  }));
};
export default SvgCameraAdd;